import State from '../interfaces/states/State';
import UserInfo from '../interfaces/UserInfo';

import { createSelector } from 'reselect';
import * as Const from '../constants';

export const activeTab$ = (state: State): number => state.findUser.activeTab;

export const authIdInputValue$ = (state: State): string => state.findUser.authIdInputValue;

export const emailInputValue$ = (state: State): string => state.findUser.emailInputValue;

export const isFindUserLoading$ = (state: State): boolean => state.findUser.isLoading;

export const userInfoData$ = (state: State): UserInfo[] => {
  if ('data' in state.findUser.userInfo) {
    if (state.findUser.userInfo.data.length) {
      return state.findUser.userInfo.data;
    } else {
      return [];
    }
  } else {
    return null;
  }
};

export const firstUserInfoItem$ = createSelector(
  userInfoData$,
  (userInfoData: UserInfo[]): UserInfo => userInfoData[0]
);
export const userInfoTableHeaders$ = createSelector(
  firstUserInfoItem$,
  (firstUserInfoItem: UserInfo): string[] => Object.keys(firstUserInfoItem).map(header => header)
);
export const preferenceItems$ = createSelector(
  firstUserInfoItem$,
  (firstUserInfoItem: UserInfo): string[] => firstUserInfoItem
    ? Object.keys(firstUserInfoItem[Const.PERSONAL_PREFERENCE]) : []
);
export const preferenceValue$ = createSelector(
  preferenceItems$,
  firstUserInfoItem$,
  (preferenceItems: string[], firstUserInfoItem: UserInfo): any[] => preferenceItems
    .map(prefItem => firstUserInfoItem[Const.PERSONAL_PREFERENCE][prefItem])
);
export const preferenceItemsSum$ = createSelector(
  preferenceItems$,
  firstUserInfoItem$,
  (preferenceItems: string[], firstUserInfoItem: UserInfo): number => preferenceItems
    .reduce((acc, value) => {
      return acc + Number(firstUserInfoItem[Const.PERSONAL_PREFERENCE][value]);
    }, 0)
);
export const percentageOfPreference$ = createSelector(
  firstUserInfoItem$,
  preferenceItemsSum$,
  preferenceItems$,
  (firstUserInfoItem: UserInfo, preferenceItemsSum: number, preferenceItems: string[]): number[] => {
    return preferenceItems.map(prefItem => {
      return Number(firstUserInfoItem[Const.PERSONAL_PREFERENCE][prefItem]) / preferenceItemsSum * 100;
    });
  }
);
export const isShowPersonalTable$ = (state: State): boolean => !isFindUserLoading$(state) && !!userInfoData$(state);

export const isEmptyData$ = (state: State): boolean => !isFindUserLoading$(state) && !isShowPersonalTable$(state);

export const isDisabled$ = (state: State): boolean => state.findUser.disabled;

export const isError$ = (state: State): boolean => state.findUser.isError;

export const isErrorWhileSearch$ = (state: State): boolean => state.findUser.isErrorWhileSearch;
